import React from 'react';
import { i18n } from 'config/locales';

import ValidationElement, {
  ValidationElementProps,
} from 'components/Form/ValidationElement/ValidationElement';
import {
  CommonOnUpdate, CommonScrollIntoView, CommonOnError, CommonRequired
} from 'types/props';
import { AccordionItemProps } from 'components/Form/Accordion/types';
import Field from 'components/Form/Field';
import Textarea from 'components/Form/Textarea';
import DateControl from 'components/Form/DateControl';
import { ForeignBusinessSubsequentContactsItemModel } from 'forms/sections/foreign/business/contact/types';

interface Props
  extends Partial<ForeignBusinessSubsequentContactsItemModel>,
    Omit<AccordionItemProps, 'name'>,
    ValidationElementProps {
  onUpdate?: CommonOnUpdate
  onError?: CommonOnError
  required?: CommonRequired
  scrollIntoView?: CommonScrollIntoView
  attribute: string
}

export default class SubsequentContactItem extends ValidationElement<Props> {
  update = (queue: Partial<ForeignBusinessSubsequentContactsItemModel>) => {
    this.props.onUpdate({
      Subsequent: this.props.Subsequent,
      Future: this.props.Future,
      Recent: this.props.Recent,
      ...queue,
    });
  };

  updateSubsequent = (values: ForeignBusinessSubsequentContactsItemModel['Subsequent']) => {
    this.update({
      Subsequent: values,
    });
  };

  updateFuture = (values: ForeignBusinessSubsequentContactsItemModel['Future']) => {
    this.update({
      Future: values,
    });
  };

  updateRecent = (values: ForeignBusinessSubsequentContactsItemModel['Recent']) => {
    this.update({
      Recent: values,
    });
  };

  render() {
    const attribute = `${this.props.attribute}.items[${this.props.$index}].Item`;
    return (
      <div>
        <Field
          title={i18n.t('foreign.business.contact.heading.subsequent')}
          attribute={`${attribute}.Subsequent`}
          adjustFor="textarea"
          scrollIntoView={this.props.scrollIntoView}
        >
          <Textarea
            name="Subsequent"
            attribute={`${attribute}.Subsequent`}
            className="foreign-business-contact-subsequent"
            {...this.props.Subsequent}
            onUpdate={this.updateSubsequent}
            onError={this.props.onError}
            required={this.props.required}
          />
        </Field>
        <Field
          title={i18n.t('foreign.business.contact.heading.recent')}
          attribute={`${attribute}.Recent`}
          help="foreign.business.contact.help.recent"
          adjustFor="datecontrol"
          scrollIntoView={this.props.scrollIntoView}
        >
          <DateControl
            name="Recent"
            attribute={`${attribute}.Recent`}
            className="foreign-business-contact-recent"
            minDateEqualTo
            {...this.props.Recent}
            onUpdate={this.updateRecent}
            onError={this.props.onError}
            required={this.props.required}
          />
        </Field>
        <Field
          title={i18n.t('foreign.business.contact.heading.future')}
          attribute={`${attribute}.Future`}
          adjustFor="textarea"
          scrollIntoView={this.props.scrollIntoView}
        >
          <Textarea
            name="Future"
            attribute={`${attribute}.Future`}
            className="foreign-business-contact-future"
            {...this.props.Future}
            onUpdate={this.updateFuture}
            onError={this.props.onError}
            required={this.props.required}
          />
        </Field>
      </div>
    );
  }
}
